import ErpCige from '../../components/erpcige/erpcige';

const ErpCigePage = () => {
  return <ErpCige />;
};

export default ErpCigePage;
